import { render, staticRenderFns } from "./RegistrarPago.vue?vue&type=template&id=1f25a181&"
import script from "./RegistrarPago.vue?vue&type=script&lang=js&"
export * from "./RegistrarPago.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports